import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import QuizTimer from './QuizTimer';
import SaveExitButton from './SaveExitButton';
import './PlayerHeader.scss';
import SubmitButton from 'legacy/packages/lrn-player/src/modules/Player/components/SubmitButton';

/**
 * Render a custom player mode container
 * with it own top bar
 */
class PlayerHeader extends PureComponent {
  static displayName = 'PlayerHeader';

  static propTypes = {
    isPreApSubject: PropTypes.bool.isRequired,
    timerInfo: PropTypes.object,
    isSoftTime: PropTypes.bool.isRequired,
    onShowModal: PropTypes.func,
    onCloseModal: PropTypes.func,
    fullName: PropTypes.string,
    timer: PropTypes.string,
    checkTimeExtension: PropTypes.func,
    checkTimeExtensionInterval: PropTypes.number,
    onTimerExpiring: PropTypes.func,
    isLearnosityReady: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    fullScreen: false,
    checkTimeExtension: () => {},
    checkTimeExtensionInterval: 30000,
    onTimerExpiring: null,
    timerInfo: {},
  };

  render() {
    const {
      pageTitle,
      timerInfo,
      isSoftTime,
      onShowModal,
      timer,
      checkTimeExtension,
      checkTimeExtensionInterval,
      onTimerExpiring,
      isLearnosityReady,
      app,
      preview,
      isDummyPlayer,
    } = this.props;

    const items = app && app.getItems && app.getItems();
    return (
      <div className="PlayerModeContainer--header-container">
        <div className="PlayerModeContainer--header">
          <div className="PlayerModeContainer--header-content">
            <div className="PlayerModeContainer--header-subject">
              <h1 className="title">{pageTitle || ''}</h1>
            </div>
            <div className="PlayerModeContainer--header-left">
              {/*<div className="PlayerModeContainer--header-student">
                {fullName}
              </div>*/}
              {timer && (
                <div className="PlayerModeContainer--header-timer">
                  {isLearnosityReady && (
                    <QuizTimer
                      timerInfo={timerInfo}
                      isSoftTime={isSoftTime}
                      onShowModal={onShowModal}
                      timer={timer}
                      checkTimeExtension={checkTimeExtension}
                      checkTimeExtensionInterval={checkTimeExtensionInterval}
                      onTimerExpiring={onTimerExpiring}
                    />
                  )}
                </div>
              )}
              {!preview && items && (
                <SubmitButton
                  app={app}
                  items={items}
                  onShowModal={onShowModal}
                  isDummyPlayer={isDummyPlayer}
                />
              )}
              {isSoftTime && ( // If this is a hard time limit final exam, hide it
                <SaveExitButton
                  isTimed={Boolean(timer)}
                  onShowModal={onShowModal}
                  isDummyPlayer={isDummyPlayer}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerHeader;
